import Q from 'q';
import usStatesTopo from 'json/usStatesTopo.json';
import * as topojson from 'topojson-client';

(function(d3, NRELMT) {

  var $self = this;
  $self.ProjectsAndPartnerships             = $self.ProjectsAndPartnerships             || {};
  $self.ProjectsAndPartnerships.initiatives = $self.ProjectsAndPartnerships.initiatives || {};

  $self.ProjectsAndPartnerships.initiatives.nps = (function() {
    var pub = {};

    var width = 760,
        height = 500,
        $wn,
        $mapSiblings,
        $mapContainer,
        $npsFeatures,
        projection,
        path,
        svg,
        parksData,
        mapIsMinified = true,
        wnResized = false,
        transitioning = false,
        HOVER_INTERVAL = 240,
        hoverIntervalFn;

    pub.init = function() {
      $mapSiblings = $('.nps-fades');
      $mapContainer = $('#cc-national-parks-index-map');
      $npsFeatures = $('.nps-features');
      $wn = $(window);

      projection = CC.projections.albersUsaVi()
        .scale(1000)
        .translate([width / 2, height / 2]);

      path = d3.geo.path()
        .projection(projection);

      svg = d3.select('#cc-national-parks-index-map').append('svg')
        .attr('width', width)
        .attr('height', height);

      parksData = new NRELMT.FeatureCollection(CC.ProjectsAndPartnerships.initiatives.npsIndexData);

      CC.utils.updateSpinner({svg:svg, loading:[1], width:width, height:height});
      _renderMap();
    };

    function _addEventListeners() {

      $mapContainer
        .on('click', _onMapClick)
        .on(CC.browser.transitionEvent, _onMapTransitionComplete);

      $npsFeatures.on(CC.browser.transitionEvent, _onNpsFeaturesTransitionComplete);
      $($mapSiblings[0]).on(CC.browser.transitionEvent, _onMapSiblingsTransitionComplete);

      svg.selectAll('.cc-item')
        .on('click', _onCcItemClick)
        .on('mouseover', _onCcItemMouseover)
        .on('mouseout', _onCcItemMouseout);

      $wn.on('resize', _onWnResize);
    }

    function _onWnResize() {
      $mapContainer.on(CC.browser.transitionEvent + '.wnResized', function(e) {
        if (e.originalEvent.propertyName.indexOf('transform') === -1) { return; }
        $mapContainer.off('.wnResized');
        // add an extra delay, hasn't seemed to be necessary, but feeling a bit paranoid
        // that npsFeatures could still be transitioning here
        // but they don't change for all win widths, so we can't easily track w/out a lot
        // of conditional logic OR isAnimating state checks and this is likely an edge-case...
        setTimeout(function() {
          wnResized = false;
        }, 300);
      });
      wnResized = true;
    }

    function _onMapSiblingsTransitionComplete(e) {
      if (e.originalEvent.propertyName !== 'opacity' || wnResized) { return; }
      if (mapIsMinified) {
        $npsFeatures.removeClass('mini');
      } else {
        mapIsMinified = true;
        transitioning = false;
      }
      e.preventDefault();
    }

    function _onNpsFeaturesTransitionComplete(e) {
      if (e.originalEvent.propertyName !== 'height' || wnResized) { return; }
      if (mapIsMinified) {
        $mapContainer.removeClass('mini');
      } else {
        $mapSiblings.addClass('mini');
      }
      e.preventDefault();
    }

    function _onMapTransitionComplete(e) {
      if (e.originalEvent.propertyName.indexOf('transform') === -1 || wnResized) { return; }
      if (mapIsMinified) {
        mapIsMinified = false;
        transitioning = false;
      } else {
        $npsFeatures.addClass('mini');
      }
      e.preventDefault();
    }

    function _onMapClick(e) {
      if (transitioning || wnResized) { return; }
      transitioning = true;

      // see transition callbacks for order
      if (mapIsMinified) {
        // mapsiblings, npsFeatures, mapContainer
        $mapSiblings.removeClass('mini');
      } else {
        // mapContainer, npsFeatures, mapSiblings
        $mapContainer.addClass('mini');
      }
      e.preventDefault();
    }

    function _onCcItemClick(d) {
      if (!d.properties.short_name || mapIsMinified) { return; }
      transitioning = true;
      window.location.href = window.location.protocol + '//' + window.location.host + '/national-parks/' + d.properties.short_name;
      return;
    }

    function _onCcItemMouseover(d) {
      if (mapIsMinified || transitioning) { return; }
      clearTimeout(hoverIntervalFn);
      hoverIntervalFn = setTimeout(function() {
        d3.selectAll('.cc-item').classed('active', false);
        d3.selectAll('.cc-item-'+d.properties.id).classed('active', true);
      }, HOVER_INTERVAL);
    }

    function _onCcItemMouseout(d) {
      if (mapIsMinified || transitioning) { return; }
      clearTimeout(hoverIntervalFn);
      hoverIntervalFn = setTimeout(function() {
        d3.selectAll('.cc-item').classed('active', true);
      }, HOVER_INTERVAL);
    }

    function _renderMap() {
      _fetchStateData()
        .then(function(res) {
          var deferred = Q.defer(); //eh, keeping the chain
          _drawStates(res);
          deferred.resolve();
          return deferred.promise;
        })
        .then(_fetchParksData)
          .then(function(res){
            _drawParks(res);
          });
    }

    function _fetchStateData() {
      var deferred = Q.defer();
      deferred.resolve(usStatesTopo);
      return deferred.promise;
    }

    function _fetchParksData() {
      var deferred = Q.defer();
      d3.json(CC.config.apiBaseUrl+'/projects/geojson?initiative=national-parks', function(err, res) {
        if(err) { deferred.reject(err); }
        deferred.resolve(res.result);
      });
      return deferred.promise;
    }

    function _drawStates(res) {
      NRELMT.Render.states({
        svgEl: svg,
        path: path,
        data: topojson.feature(res, res.objects.usStates5m).features
      });
    }

    function _drawParks(res) {
      var points = CC.utils.addRenderingData(res.points.features, {
        path: path,
        featureCollection: parksData
      }, [CC.utils.addOverrideData, CC.utils.addCentroidData, CC.utils.addTextTransformData]);
      _renderPoints(points);
      _renderLabels(points);
      _addEventListeners();
      CC.utils.updateSpinner({svg:innerSvg, loading:[], width:width, height:height});
    }

    function _renderPoints(points) {
      svg.selectAll('.cc-centerpoint')
        .data(points)
        .enter().append('circle')
          .attr('cx', function(d) {return d.properties.centroid[0];})
          .attr('cy', function(d) {return d.properties.centroid[1];})
          .attr('r', 3)
          .attr('class', function(d) {
            return 'centerPoint cc-centerpoint cc-item active cc-item-'+d.properties.id;
          });
    }

    function _renderLabels(points) {
      svg.selectAll('.cc-label')
        .data(points)
        .enter().append('text')
          .attr('class', function(d) {
            return 'cc-label cc-item active cc-item-'+d.properties.id;
          })
          .attr('transform', function(d) { return d.properties.textTransform;})
          .text(function(d) {
            var id = +d.properties.id;
            return parksData.get(id.toString()).get('location_point_label') ||  d.properties.location_point_label;
          });
    }

    return pub;
  })();



}).call(CC, d3, NRELMT);

$(".cc-national-parks-index-map").on("click", function(){
  $(".close-map").toggleClass("hidden");
});
